import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { User } from "./../interfaces/user";

@Injectable({
  providedIn: "root"
})
export class UserService {

  constructor(
    private http: HttpClient
    ) { }

  createUser(user: User){
    const path = "https://api-login-heroku.herokuapp.com/signup";
    // const path = "http://localhost:4000/signup";
    return this.http.post(path, user);
  }

  getUser(user: User){
    const path2 = "https://api-login-heroku.herokuapp.com/signin";
    // const path2 = "http://localhost:4000/signin";
    return this.http.post(path2, user);
  }
}
